import React, { useEffect, useState, useRef } from "react";
import { observer } from "mobx-react";
import { Link } from "react-router-dom";
import PlaylistArticle from "./PlaylistArticle";
import loadingIcon from "../../../Assets/loading.gif";
import store from "../store";
// import Intercom from '@intercom/messenger-js-sdk';
import { CircularProgress } from "@mui/material";

const Articles = observer(
  ({
    articles,
    trackingId,
    addArticleToPlaylist,
    selectArticle,
    togglePlayed,
    removeArticle,
    changeMode,
  }) => {
    const { currentArticle, isPlaying, playlistMode } = store;
    const [visibleArticles, setVisibleArticles] = useState([]);
    const loadMoreRef = useRef(null);

    // useEffect(() => {
    //   Intercom({
    //     app_id: "fduylg2r", 
    //     hide_default_launcher: false,
    //     mobile: true,
    //   });
    // }, []);

    useEffect(() => {
      if (!articles) return;
      // Always update visible articles when articles change
      setVisibleArticles(prev => {
        // Keep same number of visible articles but with updated content
        const numVisible = prev.length || 10;
        return articles.slice(0, numVisible);
      });
    }, [articles]); // Depend on articles, not just length

    useEffect(() => {
      if (!articles) return;
      
      const observer = new IntersectionObserver(
        (entries) => {
          const [entry] = entries;
          if (entry.isIntersecting) {
            setVisibleArticles(prev => {
              if (prev.length >= articles.length) return prev;
              const nextBatch = articles.slice(prev.length, prev.length + 10);
              return [...prev, ...nextBatch];
            });
          }
        },
        { threshold: 0.1 }
      );

      const currentRef = loadMoreRef.current;
      if (currentRef) {
        observer.observe(currentRef);
      }

      return () => {
        if (currentRef) {
          observer.unobserve(currentRef);
        }
        observer.disconnect();
      };
    }, [articles]); // Depend on articles, not just length

    // Filtering logic
    let filteredArticles = articles || [];
    if (playlistMode === 'played') {
      filteredArticles = filteredArticles.filter(a => a.played);
    } else if (playlistMode === 'unplayed') {
      filteredArticles = filteredArticles.filter(a => !a.played);
    }
    // In 'all', show all

    return (
      <div className="article-container">
        <div style={{ padding: '0 24px' }}>
          <Link 
            to="/add" 
            style={{
              display: 'flex',
              alignItems: 'center',
              padding: '8px 16px',
              margin: '10px 0',
              borderRadius: '6px',
              background: 'rgba(66, 146, 250, 0.1)',
              color: '#4292fa',
              textDecoration: 'none',
              fontWeight: '500',
              fontSize: '14px',
              border: '1px solid rgba(66, 146, 250, 0.2)',
              cursor: 'pointer',
              transition: 'all 0.2s ease',
              width: 'fit-content'
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.background = 'rgba(66, 146, 250, 0.15)';
              e.currentTarget.style.borderColor = 'rgba(66, 146, 250, 0.3)';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.background = 'rgba(66, 146, 250, 0.1)';
              e.currentTarget.style.borderColor = 'rgba(66, 146, 250, 0.2)';
            }}
          >
            + Add Article
          </Link>
        </div>
        {articles === null ? (
          <div className="feeds-loading-container" style={{ 
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            padding: '100px 20px',
            gap: '20px'
          }}>
            <CircularProgress 
              size={40} 
              sx={{
                color: '#4292fa',
                '@keyframes gradient': {
                  '0%': { color: '#4292fa' },
                  '25%': { color: '#8535cd' },
                  '50%': { color: '#e82186' },
                  '75%': { color: '#ff5c57' },
                  '100%': { color: '#4292fa' }
                },
                animation: 'gradient 2s ease infinite'
              }}
            />
            <p style={{ 
              color: '#fff',
              fontSize: '16px',
              fontWeight: 500,
              background: 'linear-gradient(90deg, #4292fa, #8535cd, #e82186, #ff5c57)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundSize: '300% 100%',
              animation: 'gradient 2s ease infinite'
            }}>Loading playlist...</p>
          </div>
        ) : filteredArticles.length > 0 ? (
          <>
            {visibleArticles
              .filter(a => filteredArticles.some(fa => fa.article_id === a.article_id))
              .map((article) => (
                <PlaylistArticle
                  key={article.article_id}
                  {...{
                    article,
                    trackingId,
                    addArticleToPlaylist,
                    selectArticle,
                    togglePlayed,
                    removeArticle,
                    isActive: isPlaying && currentArticle && currentArticle.article_id === article.article_id,
                    showPlayedCheckbox: playlistMode === 'all' || playlistMode === 'played',
                  }}
                />
              ))}
            {visibleArticles.length < filteredArticles.length && (
              <div ref={loadMoreRef} style={{ height: '20px' }} />
            )}
          </>
        ) : (
          <div style={{ 
            textAlign: 'center', 
            color: 'white',
            width: '100%',
            padding: '100px 20px'
          }}>You don't have any {playlistMode === 'unplayed' ? 'unplayed' : 'played'} articles. To add some, <Link to="/">subscribe to a feed</Link> or <Link to="/add">add an article manually</Link>.</div>
        )}
      </div>
    );
  }
);

export default Articles;
